<template>
  <div :style="`width:${dispW}px;height:${dispH}px`">
    <!-- <div class="trend-chart" :style="`width:${dispW-10}px;height:${dispH}px`">
      <canvas id="chart" :style="`width:${dispW-10}px;height:${dispH}px`"></canvas>
    </div>-->
  </div>
</template>
<script>
// var color = Chart.helpers.color;
var randomScalingFactor = function () {
  return Math.round(Math.random() * 100);
};

let _data = [10, 30, 100, 250, 50, "-", "-", "-", "-", "-"];
let _data2 = ["-", "-", "-", "-", 50, 1, 30, 100, 200, 50];
let dataall = [..._data, ..._data2].filter((d) => {
  return d !== "-";
});
function createConfig(legendPosition, colorName, bk) {
  // Chart.defaults.global.scaleFontColor = "#FFF"
  // return {
  //   type: 'line',
  //   data: {
  //     labels: [0, 1, 2, 3, 4, 5, 6, 7, 9, 10],
  //     datasets: [{
  //       label: 'My First dataset',
  //       data: _data,
  //       backgroundColor: bk,
  //       borderColor: 'white',
  //       borderWidth: 1,
  //       borderDash: [4, 5],
  //       color: "white",
  //       radius: 0
  //     }, {
  //       label: 'My First dataset',
  //       data: _data2,
  //       backgroundColor: bk,
  //       borderColor: 'white',
  //       borderWidth: 1,
  //       radius: 0
  //     }]
  //   },
  //   options: {
  //     spanGaps: false,
  //     tooltips: {
  //       enabled: false,
  //       display: false
  //     },
  //     legend: {
  //       display: false,
  //       labels: {
  //         fontColor: 'rgb(255, 99, 132)'
  //       }
  //     },
  //     scales: {
  //       xAxes: [{
  //         // 背景网格
  //         gridLines: {
  //           // 取消x轴的竖线
  //           display: false,
  //           // 设置x轴线颜色
  //           color: "gray",
  //         },
  //         ticks: {
  //           fontColor: "#fff",
  //         }
  //       }],
  //       // y轴
  //       yAxes: [{
  //         gridLines: {
  //           color: "gray",
  //           // 以点线显示
  //           borderDash: [2, 5],
  //         },
  //         ticks: {
  //           fontColor: "#fff",
  //         }
  //         // 设置起止数据和步长
  //       }]
  //     }
  //   }
  // }
}
export default {
  name: "TrendChart",
  data() {
    return {};
  },
  props: {
    dispW: {
      type: Number,
      default: 945
    },
    dispH: {
      type: Number,
      default: 300
    }
  },
  mounted() {
    // this.drawChart()
  },
  methods: {
    drawChart() {
      var ctx = document.getElementById("chart").getContext("2d");
      let max = Math.max(...dataall);
      let scale = this.dispH / max;

      var gradient = ctx.createLinearGradient(0, 0, 0, this.dispH - 35);
      gradient.addColorStop(0, "green");
      gradient.addColorStop((max - 90) / max, "green");
      gradient.addColorStop(1, "black");
      [
        {
          id: "chart",
          legendPosition: "top",
          color: "red",
          backgroundColor: gradient
        }
      ].forEach(function (details) {
        var config = createConfig(details.legendPosition, details.color, details.backgroundColor);
        new Chart(ctx, config);
      });
    }
  }
};
</script>
<style scoped>
.trend-chart {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/TrendChart.vue